import React from "react";
import { useNavigate } from "react-router-dom";
import {
  CalculatorOutlined,
  CloseOutlined,
  DollarOutlined,
  DownOutlined,
  EditFilled,
  ExclamationCircleOutlined,
  ImportOutlined,
  InfoCircleOutlined,
  SendOutlined,
} from "@ant-design/icons";
import swal from "sweetalert";
import { t } from "i18next";
import moment from "moment";
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Dropdown,
  Form,
  Input,
  InputMonth,
  InputTextArea,
  Menu,
  NumberInput,
  Result,
  Row,
  SearchOutlined,
  SelectInput,
  Spin,
  Table,
  Tag,
} from "common/elements";
import { Util } from "common/util";
import {
  changeSeverancepay,
  generatePayroll,
  getCoshSharing,
  getMany,
  markAsApproved,
  markAsRejected,
  markAsReviewed,
  processPayroll,
  submitPayroll,
} from "services/payroll";
import { getResignedEmployes } from "services/employee";
import "./index.css";
import { InputNumber, Modal } from "antd";

export default function withDataTable({
  title = "",
  addImportLink = "",
  addViewLink = "",
  updateLink = "",
  pathName = "/",
  dateFormat = "",
  datePlaceholder = "",
  pickerDate = "",
  permission = null,
  getData = () => {},
  showFetchListDate = true,
  handleShowUpdate = (id, modalRef) => {},
  componentWillMount = () => {},
  handleSearch = (e) => {},
}) {
  return () => {
    const [state] = React.useState({
      loading: false,
      caApprove:
        Util.getInstance().hasPermission("approve", permission) ||
        localStorage.getItem("IN_ACTING"),
    });
    const [payrolls, setPayrolls] = React.useState([]);
    const [payrollItems, setPayrollItems] = React.useState([]);
    const [groupPayroll, setGroupPayroll] = React.useState(null);
    const [summaryPayroll, setSummaryPayroll] = React.useState({
      firstNetPayment: 0,
      secondNetPayment: 0,
      numberOfPayroll: 0,
      netPay: 0,
    });

    const [isModalSeverancePay, setIsModalSeverancePay] = React.useState(false);

    const [severancePayFinal, setSeverancePayFinal] = React.useState({
      id: 0,
      employeeId: 0,
      severancePay: 0,
    });
    const [pagination, setPagination] = React.useState({
      count: 0,
      total: 0,
      offset: 0,
      limit: 0,
    });
    const params = new URLSearchParams(document.location.search);
    const navigate = useNavigate();
    let modalRef = React.createRef();
    let noPermission = false;
    let timer = null;

    const fetchList = () => {
      getData()
        .then((response) => {
          console.log("response.groupPayroll",response.groupPayroll)
          setPayrolls(response.data);
          setPayrollItems(response.payrollItems);
          setGroupPayroll(response.groupPayroll);
          setSummaryPayroll(response.summary);
          setPagination(response.pagination);
        })
        .catch((error) => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            navigate("/signin");
          }
        });
    };

    const onSearch = (e) => {
      clearTimeout(timer);
      handleSearch(e);
      timer = setTimeout(() => {
        fetchList();
      }, 1000);
    };

    const hadleOpenModalSeverancePay = (record) => {
      setIsModalSeverancePay(true);
      setSeverancePayFinal({
        id: record.id,
        employeeId: record.employeeId,
        severancePay: record.severancePay,
      });
    };

    const onImport = () => {
      navigate(addImportLink);
    };

    const onShowDetail = (record) => {
      let hasNoPermission = false;
      if (
        permission &&
        permission === "approval" &&
        Util.getInstance().hasNoPermission("review", permission)
      ) {
        hasNoPermission = true;
      }

      if (hasNoPermission) {
        Util.getInstance().sweetAlertMessage(
          t("text_no_permission"),
          "warning"
        );
      } else {
        navigate(
          `${addViewLink}/${record.id}?isProceedFinalPay=${record.isProceedFinalPay}`
        );
      }
    };

    const onShowUpdateForm = (id) => {
      let hasNoPermission = false;
      if (
        permission &&
        Util.getInstance().hasNoPermission("edit", permission)
      ) {
        hasNoPermission = true;
      }

      if (hasNoPermission) {
        Util.getInstance().sweetAlertMessage(
          t("text_no_permission"),
          "warning"
        );
      } else {
        if (updateLink) {
          navigate(`${updateLink}/${id}`);
        } else {
          handleShowUpdate(id, modalRef);
        }
      }
    };

    const onSubmitPayroll = () => {
      swal({
        title: "Are you sure?",
        text: "You are about to submit payroll for verification.",
        icon: "warning",
        buttons: ["Cancel", "Submit"],
        dangerMode: true,
      }).then((willApprove) => {
        if (willApprove) {
          submitPayroll(groupPayroll.id).then(() => {
            swal(
              "Submitted",
              "You have successfully submitted payroll",
              "success"
            ).then(() => {
              fetchList();
            });
          });
        } else {
          swal("Cancelled", "Payroll submission was cancelled", "error");
        }
      });
    };

    const onMarkAsReviewed = () => {
      swal({
        title: "Are you sure?",
        text: "You are about to submit payroll for approval.",
        icon: "warning",
        buttons: ["Cancel", "Submit"],
        dangerMode: true,
      }).then((willReview) => {
        if (willReview) {
          markAsReviewed(groupPayroll.id).then(() => {
            swal(
              "Verified",
              "You are successfully verified and submitted payroll for approval",
              "success"
            ).then(() => {
              fetchList();
            });
          });
        } else {
          swal("Cancelled", "Payroll verification was cancelled", "error");
        }
      });
    };

    const onMarkAsApproved = () => {
      swal({
        title: "Are you sure?",
        text: "You are about to approve payroll.",
        icon: "warning",
        buttons: ["Cancel", "Approve"],
        dangerMode: true,
      }).then((willApprove) => {
        if (willApprove) {
          markAsApproved(
            groupPayroll.id,
            params.has("date") ? params.get("date") : moment().format("YYYY-MM")
          )
            .then(() => {
              swal("Approved!", "You've approved payroll!", "success").then(
                () => {
                  fetchList();
                }
              );
            })
            .catch((error) => {
              swal({
                title: "Opps!",
                text: error?.response?.data?.error?.message,
                icon: "error",
                dangerMode: true,
              });
            });
        } else {
          swal("Cancelled", "Payroll approval was cancelled", "error");
        }
      });
    };

    const [loadingSeverancePay, setLoadingSeverancePay] = React.useState(false);

    const onChangeSeverancePay = () => {

      swal({
        title: "Are you sure?",
        text: "You are about to change severance pay.",
        icon: "warning",
        buttons: ["Cancel", "Change"],
        dangerMode: true,
      }).then((willApprove) => {
        if (willApprove) {
        setLoadingSeverancePay(true);
          changeSeverancepay({...severancePayFinal,year: params.has("date") ? moment(params.get("date")).format("YYYY") : moment().format("YYYY")})
            .then(() => {
              swal("Updated!", "You've changed severance pay!", "success").then(
                () => {
                  fetchList();
                  setIsModalSeverancePay(false);
                  setLoadingSeverancePay(false);
                  setSeverancePayFinal({
                    id: 0,
                    employeeId: 0,
                    severancePay: 0,
                  });
                }
              );
            })
            .finally(() => setLoadingSeverancePay(false));
        }
      });
    };

    React.useMemo(() => {
      componentWillMount();
    }, []);

    React.useEffect(() => {
      fetchList();
      // eslint-disable-next-line
    }, []);

    if (
      permission &&
      Util.getInstance().hasNoPermission("view", permission) &&
      !state.caApprove
    ) {
      noPermission = true;
    }

    if (noPermission) {
      return (
        <Result
          status="403"
          title="403"
          subTitle={t("text_sorry_you_are_not_authorized_to_access_this_page")}
        />
      );
    }

    const bgHeaders = {
      0: "#92d050",
      1: "#ffff00",
      2: "#ff0000",
      4: "#ff0000",
      5: "#ff0000",
      6: "#92d050",
    };

    let monthlyPayBasic = 0;
    let monthlyCurrentPayBasic = 0;
    let totalNetPay = 0;
    let accrual13thMonth = 0;
    let uptodateAccrual13thMonth = 0;
    let accrualSeniority = 0;
    let accrualSeniorityUptoDate = 0;
    let accrualSeverancePay = 0;
    let uptodateAccrualSeverancePay = 0;
    let accrualPFOrganization = 0;
    let PFOrganization = 0;
    let PFStaff = 0;

    let exchangeRate = 0;
    let nssfExchangeRate = 0;
    if (groupPayroll) {
      exchangeRate = groupPayroll.exchangeRate;
      nssfExchangeRate = groupPayroll.nssfExchangeRate;
    }

    return (
      <>
        <Row style={styles.breadCream}>
          <Col span={24}>
            <Breadcrumb>
              <Breadcrumb.Item
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
              >
                {t("text_dashboard")}
              </Breadcrumb.Item>
              <Breadcrumb.Item style={{ color: "#1d8747" }}>
                {title}
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>

        <Row style={{ padding: 15, paddingBottom: 0 }}>
          <Col span={8}>
            <div style={{ display: "flex" }}>
              <Title title={title} />
              {groupPayroll ? (
                <div style={{ marginLeft: 15 }}>
                  {groupPayroll.status === "PROCESSED" && (
                    <Tag color="#ADD8E6" style={{ borderRadius: 40 }}>
                      Processed
                    </Tag>
                  )}
                  {groupPayroll.status === "SUBMITTED" && (
                    <Tag
                      color="#FFFF00"
                      style={{ borderRadius: 40, color: "black" }}
                    >
                      Submitted
                    </Tag>
                  )}
                  {groupPayroll.status === "VERIFIED" && (
                    <Tag
                      color="#00FF00"
                      style={{ borderRadius: 40, color: "black" }}
                    >
                      Reviewed
                    </Tag>
                  )}
                  {groupPayroll.status === "REJECTED" && (
                    <Tag
                      color="#ff4d4f"
                      style={{ borderRadius: 40, color: "#fff" }}
                    >
                      Rejected
                    </Tag>
                  )}
                  {groupPayroll.status === "APPROVED" && (
                    <Tag
                      color="rgb(135, 208, 104)"
                      style={{ borderRadius: 40 }}
                    >
                      Approved
                    </Tag>
                  )}
                </div>
              ) : payrolls.length > 0 ? (
                <div style={{ marginLeft: 15 }}>
                  <Tag color="rgb(240, 173, 78)" style={{ borderRadius: 40 }}>
                    Generated
                  </Tag>
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col span={16} style={{ textAlign: "right", bottom: "5px" }}>
            <Input
              placeholder={t("text_search")}
              defaultValue={params.get("search")}
              prefix={<SearchOutlined />}
              style={styles.generalSearch}
              allowClear={true}
              onChange={onSearch}
            />

            <MonthPicker
              fetchList={fetchList}
              pathName={pathName}
              dateFormat={dateFormat}
              datePlaceholder={datePlaceholder}
              showFetchListDate={showFetchListDate}
              pickerDate={pickerDate}
            />

            {Util.getInstance().hasPermission("generate", permission) && (
              <GeneratePayroll onReload={fetchList} />
            )}
            {Util.getInstance().hasPermission("import", permission) && (
              <Button
                type="primary"
                className="btn-import"
                icon={<ImportOutlined />}
                style={{ marginLeft: 15 }}
                onClick={onImport}
              >
                {t("text_import")}
              </Button>
            )}

            {Util.getInstance().hasPermission("export", permission) && (
              <ExportButton />
            )}

            {Util.getInstance().hasPermission("process", permission) &&
              React.useMemo(
                () => (
                  <ProcessPayRoll
                    onReload={fetchList}
                    groupPayroll={groupPayroll}
                  />
                ),
                // eslint-disable-next-line
                [groupPayroll]
              )}

            {Util.getInstance().hasPermission("submit", permission) &&
              groupPayroll?.status === "PROCESSED" && (
                <Button
                  icon={<SendOutlined />}
                  style={{
                    marginLeft: 15,
                    backgroundColor: "rgb(184 184 0)",
                    borderColor: "rgb(184 184 0)",
                    color: "white",
                  }}
                  type="primary"
                  onClick={onSubmitPayroll}
                >
                  {t("text_submit")}
                </Button>
              )}

            {Util.getInstance().hasPermission("verify", permission) &&
              groupPayroll?.status === "SUBMITTED" && (
                <>
                  <RejectPayroll
                    groupPayrollId={groupPayroll?.id}
                    onReload={fetchList}
                  />
                  <Button
                    style={{
                      marginLeft: 15,
                      backgroundColor: "#87D068",
                      borderColor: "#87D068",
                    }}
                    type="primary"
                    onClick={onMarkAsReviewed}
                  >
                    {t("text_mark_as_reviewed")}
                  </Button>
                </>
              )}

            {state.caApprove && groupPayroll?.status === "VERIFIED" && (
              <>
                <RejectPayroll
                  groupPayrollId={groupPayroll?.id}
                  onReload={fetchList}
                />
                <Button
                  style={{
                    marginLeft: 15,
                    backgroundColor: "#87D068",
                    borderColor: "#87D068",
                  }}
                  type="primary"
                  onClick={onMarkAsApproved}
                >
                  {t("text_mark_as_approved")}
                </Button>
              </>
            )}
          </Col>
        </Row>
        <div
          style={{
            marginBottom: 5,
            display: "flex",
            justifyContent: "space-between",
            fontSize: 11,
          }}
        >
          <div style={{ marginLeft: 400 }}>
            {t("text_exchange_rate")}: {exchangeRate}
          </div>
          <div style={{ marginRight: 184 }}>
            Exchange Rate for NSSF: {nssfExchangeRate}
          </div>
        </div>
        <div>
          <div
            className="data-table"
            style={{
              display: "block",
              overflowY: "hidden",
              overflowX: "scroll",
              margin: "0 auto",
              marginLeft: 282,
              width: document.getElementById("main-content-layout") ? document.getElementById("main-content-layout").offsetWidth - 466 : 0,
            }}
          >
            <table id="payroll">
              <thead>
                <tr>
                  <th className="frozencol1">
                    <div style={{ height: 34, lineHeight: "34px" }}>
                      {t("text_no")}
                    </div>
                  </th>
                  <th className="frozencol2">
                    <div style={{ height: 34, lineHeight: "34px" }}>
                      {t("text_employee_id")}
                    </div>
                  </th>
                  <th className="frozencol3">
                    <div style={{ height: 34, lineHeight: "34px" }}>
                      {t("text_employee_name")}
                    </div>
                  </th>
                  <th style={{ textAlign: "center" }}>{t("text_position")}</th>
                  <th style={{ textAlign: "center" }}>{t("text_team")}</th>
                  <th style={{ textAlign: "center" }}>{t("text_gender")}</th>
                  <th style={{ textAlign: "center" }}>
                    {t("text_duty_station")}
                  </th>
                  <th style={{ textAlign: "center" }}>D.O.E</th>
                  <th style={{ textAlign: "center" }}>
                    <div style={{ width: 60, whiteSpace: "break-spaces" }}>
                      Contract End Date
                    </div>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    <div style={{ width: 60, whiteSpace: "break-spaces" }}>
                      Status
                    </div>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    <div style={{ width: 80, whiteSpace: "break-spaces" }}>
                      Last Working Day
                    </div>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    <div style={{ width: 80, whiteSpace: "break-spaces" }}>
                      Payroll Start Date
                    </div>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    <div style={{ width: 80, whiteSpace: "break-spaces" }}>
                      Payroll End Date
                    </div>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    <div style={{ width: 100, whiteSpace: "break-spaces" }}>
                      Monthly Pay Basic
                    </div>
                  </th>
                  {/* <th style={{ textAlign: "center" }}><div style={{ width: 100, whiteSpace: "break-spaces" }}>Current Month Working Day</div></th> */}
                  <th style={{ textAlign: "center" }}>
                    <div style={{ width: 100, whiteSpace: "break-spaces" }}>
                      Actual Working Day
                    </div>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    <div style={{ width: 100, whiteSpace: "break-spaces" }}>
                      Monthly Current Pay Basic
                    </div>
                  </th>

                  {/* DYNAMIC PAYROLL ITEMS */}
                  {payrollItems.map((payrollItem, index) => {
                    if (
                      payrollItem.code === "nssf_occupational_accident" ||
                      payrollItem.code === "nssf_health_care" ||
                      payrollItem.code === "total_nssf_both_staff_npa"||
                        payrollItem.code === "gross_pay_second_pay"
                    ) {
                      return (
                        <th
                          key={index}
                          style={{
                            display: "none",
                          }}
                          title={payrollItem.format}
                        >
                          <div
                            style={
                              payrollItem.columnWidth
                                ? {
                                    width: payrollItem.columnWidth,
                                    whiteSpace: "break-spaces",
                                  }
                                : {}
                            }
                          >
                            {payrollItem.title}
                          </div>
                        </th>
                      );
                    } else {
                      return (
                        <th
                          key={index}
                          style={{
                            backgroundColor: bgHeaders[payrollItem.type],
                            textAlign: "center",
                          }}
                          title={payrollItem.format}
                        >
                          <div
                            style={
                              payrollItem.columnWidth
                                ? {
                                    width: payrollItem.columnWidth,
                                    whiteSpace: "break-spaces",
                                  }
                                : {}
                            }
                          >
                            {payrollItem.title}
                          </div>
                        </th>
                      );
                    }
                  })}
                  {/* DYNAMIC PAYROLL ITEMS */}

                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 102, whiteSpace: "break-spaces" }}>
                      Monthly Accrual 13th Salary
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 102, whiteSpace: "break-spaces" }}>
                      Uptodate Accrual 13th Salary
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 120, whiteSpace: "break-spaces" }}>
                      Monthly Accrual Seniority Indemnity
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 120, whiteSpace: "break-spaces" }}>
                      Uptodate Accrual Seniority Indemnity
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 120, whiteSpace: "break-spaces" }}>
                      Monthly Accrual Severance Pay
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 102, whiteSpace: "break-spaces" }}>
                      Uptodate Accrual Severance Pay
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 140, whiteSpace: "break-spaces" }}>
                      Monthly Provident Fund - NPA Contribution
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 102, whiteSpace: "break-spaces" }}>
                      Provident Fund - NPA Uptodate
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 150, whiteSpace: "break-spaces" }}>
                      Uptodate Provident Fund - Staff Contribution
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    <div style={{ width: 150, whiteSpace: "break-spaces" }}>
                      Uptodate Provident Fund - Staff and NPA
                    </div>
                  </th>

                  <th className="frozennetpay">
                    <div style={{ height: 34, lineHeight: "34px" }}>
                      {t("text_netpay")}
                    </div>
                  </th>
                  <th className="frozenaction">
                    <div style={{ height: 34, lineHeight: "34px" }}>
                      {t("text_action")}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {payrolls.map((payroll, key1) => {
                  const payrollEntries = payroll.payload ? payroll.payload : [];
                  payroll.currentBasicSalary = payroll.currentBasicSalary ? payroll.currentBasicSalary : 0;
                  payroll.accrualAnnualSalary = payroll.accrualAnnualSalary ? payroll.accrualAnnualSalary : 0;
                  payroll.annualSalary = payroll.annualSalary ? payroll.annualSalary : 0;
                  payroll.accrualSeniority = payroll.accrualSeniority ? payroll.accrualSeniority : 0;
                  payroll.accrualSeverancePay = payroll.accrualSeverancePay ? payroll.accrualSeverancePay : 0;
                  payroll.severancePay = payroll.severancePay ? payroll.severancePay : 0;
                  payroll.accrualPFOrganization = payroll.accrualPFOrganization ? payroll.accrualPFOrganization : 0;
                  payroll.PFOrganization = payroll.PFOrganization ? payroll.PFOrganization : 0;
                  payroll.PFStaff = payroll.PFStaff ? payroll.PFStaff : 0;
                  payroll.PFOrganizationAndStaff = payroll.PFOrganization + payroll.PFStaff;
                  const exchangeRate = payroll.exchangeRate;
                  monthlyPayBasic += payroll.basicSalary;
                  monthlyCurrentPayBasic += payroll.currentBasicSalary;
                  accrual13thMonth += payroll.accrualAnnualSalary;
                  uptodateAccrual13thMonth += payroll.annualSalary;
                  accrualSeniority += payroll.accrualSeniority;
                  accrualSeniorityUptoDate += payroll.accrualSeniorityUptoDate ? payroll.accrualSeniorityUptoDate : 0;
                  accrualSeverancePay += payroll.accrualSeverancePay;
                  uptodateAccrualSeverancePay += payroll.severancePay;
                  accrualPFOrganization += payroll.accrualPFOrganization;
                  PFOrganization += payroll.PFOrganization;
                  PFStaff += payroll.PFStaff;
                  totalNetPay += payroll.netPay;

                  return (
                    <tr key={key1} className="data-row">
                      <td className="frozencol1">{key1 + 1}</td>
                      <td className="frozencol2">
                        <div style={{ minWidth: 80 }}>
                          {payroll.employeeCode}
                        </div>
                      </td>
                      <td className="frozencol3">
                        <div style={{ minWidth: 150 }}>
                          {payroll.employeeName}{" "}
                          {payroll.lastWorkingDay ? (
                            <ExclamationCircleOutlined
                              style={{
                                color: "#ff0000",
                                fontSize: 12,
                                fontWeight: "bold",
                                marginLeft: 3,
                              }}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                        {payroll.lastWorkingDay ? (
                          <div className="payroll-remark">
                            <b>Resigned</b> - Last Day on{" "}
                            {moment(payroll.lastWorkingDay).format(
                              "MMMM DD, YYYY"
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>{payroll.position}</td>
                      <td>{payroll.team}</td>
                      <td>
                        {
                          {
                            0: t("text_male"),
                            1: t("text_female"),
                            2: t("text_other"),
                          }[payroll.gender]
                        }
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {payroll.dutyStation === "CO"
                          ? "CO"
                          : "Field Operation"}
                      </td>
                      <td>
                        {payroll.joinDate
                          ? moment(payroll.joinDate).format("DD-MMM-YY")
                          : ""}
                      </td>

                      <td>
                        {payroll.contractEndDate
                          ? moment(payroll.contractEndDate).format("DD-MMM-YY")
                          : ""}
                      </td>
                      <td>
                        {
                          {
                            0: "New",
                            1: "Active",
                            2: "Terminate",
                            3: "Inactive",
                          }[payroll.status]
                        }
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {payroll.lastWorkingDay
                          ? moment(payroll.lastWorkingDay).format("DD-MMM-YY")
                          : ""}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {payroll.fromDate
                          ? moment(payroll.fromDate).format("DD-MMM-YY")
                          : ""}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {payroll.toDate
                          ? moment(payroll.toDate).format("DD-MMM-YY")
                          : ""}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {Util.getInstance().formatCurrency(payroll.basicSalary)}
                      </td>
                      {/* <td style={{ textAlign: "center" }}>{payroll.expectedPayableDay}</td> */}
                      <td style={{ textAlign: "center" }}>
                        {payroll.workedDay}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {Util.getInstance().formatCurrency(
                          payroll.currentBasicSalary
                        )}
                      </td>
                      {payrollItems.map((payrollItem, key2) => {
                        if (
                          payrollItem.code === "nssf_occupational_accident" ||
                          payrollItem.code === "nssf_health_care" ||
                          payrollItem.code === "total_nssf_both_staff_npa" ||
                            payrollItem.code === "gross_pay_second_pay"
                        ) {
                          return (
                            <td key={key2} style={{ display: "none" }}>
                              <div style={{ minWidth: 60 }}></div>
                            </td>
                          );
                        } else {
                          let amount = 0;
                          const foundPayrollEntry = payrollEntries.find(
                            (payrollEntry) => payrollEntry.k === payrollItem.code
                          );
                          if (foundPayrollEntry) {
                            amount = foundPayrollEntry.a;

                            if (amount && payrollItem.format === "USD") {
                              amount = amount.toFixed(2);
                            }

                            if (!payrollItem["amount"]) {
                              payrollItem["amount"] = 0;
                            }

                            payrollItem["amount"] += parseFloat(amount);
                          }

                          if (payrollItem.format === "NONE") {
                            return (
                              <td key={key2} style={{ textAlign: "center" }}>
                                <div style={{ minWidth: 60 }}>
                                  {amount
                                    ? parseFloat(amount)
                                        .toFixed(1)
                                        .replace(/\.0+$/, "")
                                    : "-"}
                                </div>
                              </td>
                            );
                          } else if (payrollItem.format === "KHR") {
                            return (
                              <td key={key2} style={{ textAlign: "right" }}>
                                <div style={{ minWidth: 60 }}>
                                  {amount
                                    ? Util.getInstance().formatCurrencyKHR(
                                        amount * exchangeRate
                                      )
                                    : "-"}
                                </div>
                              </td>
                            );
                          } else if (payrollItem.format === "KHR-FIXED") {
                            return (
                              <td key={key2} style={{ textAlign: "right" }}>
                                <div style={{ minWidth: 60 }}>
                                  {amount
                                    ? Util.getInstance().formatCurrencyKHR(
                                        amount * 4000
                                      )
                                    : "-"}
                                </div>
                              </td>
                            );
                          } else if (payrollItem.format === "PERCENTAGE") {
                            return (
                              <td key={key2} style={{ textAlign: "center" }}>
                                <div style={{ minWidth: 60 }}>
                                  {amount
                                    ? `${parseFloat(amount)
                                        .toFixed(1)
                                        .replace(/\.0+$/, "")}%`
                                    : "-"}
                                </div>
                              </td>
                            );
                          }

                          return (
                            <td key={key2} style={{ textAlign: "right" }}>
                              <div style={{ minWidth: 60 }}>
                                {amount
                                  ? Util.getInstance().formatCurrency(amount)
                                  : "-"}
                              </div>
                            </td>
                          );
                        }
                      })}
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.accrualAnnualSalary
                            ? Util.getInstance().formatCurrency(
                                payroll.accrualAnnualSalary
                              )
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.annualSalary
                            ? Util.getInstance().formatCurrency(
                                payroll.annualSalary
                              )
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.accrualSeniority
                            ? Util.getInstance().formatCurrency(
                                payroll.accrualSeniority
                              )
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.accrualSeniorityUptoDate
                            ? Util.getInstance().formatCurrency(
                                payroll.accrualSeniorityUptoDate
                              )
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.accrualSeverancePay
                            ? Util.getInstance().formatCurrency(
                                payroll.accrualSeverancePay
                              )
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.severancePay
                            ? Util.getInstance().formatCurrency(
                                payroll.severancePay
                              )
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.accrualPFOrganization
                            ? Util.getInstance().formatCurrency(
                                payroll.accrualPFOrganization
                              )
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.PFOrganization
                            ? Util.getInstance().formatCurrency(
                                payroll.PFOrganization
                              )
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.PFStaff
                            ? Util.getInstance().formatCurrency(payroll.PFStaff)
                            : "-"}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ minWidth: 60 }}>
                          {payroll.PFOrganizationAndStaff
                            ? Util.getInstance().formatCurrency(
                                payroll.PFOrganizationAndStaff
                              )
                            : "-"}
                        </div>
                      </td>
                      <td className="frozennetpay">
                        {payroll.netPay
                          ? Util.getInstance().formatCurrency(payroll.netPay)
                          : "-"}
                      </td>
                      <td className="frozenaction">
                        <span style={{ visibility: "hidden" }}>-</span>
                        <Button
                          type="default"
                          shape="circle"
                          icon={
                            <InfoCircleOutlined
                              style={{
                                fontSize: 10,
                                position: "absolute",
                                top: 2,
                                left: 1.5,
                              }}
                            />
                          }
                          onClick={() => onShowDetail(payroll)}
                          style={{
                            minWidth: 16,
                            width: 16,
                            height: 16,
                            position: "absolute",
                            left: 10,
                          }}
                        />
                        {Util.getInstance().hasPermission(
                          "edit",
                          "payroll"
                        ) && (
                          <Button
                            type="primary"
                            shape="circle"
                            icon={
                              <EditFilled
                                style={{
                                  fontSize: 10,
                                  position: "absolute",
                                  top: 2,
                                  left: 1.5,
                                }}
                              />
                            }
                            onClick={() => onShowUpdateForm(payroll.id)}
                            style={{
                              minWidth: 16,
                              width: 16,
                              height: 16,
                              position: "absolute",
                              left: 28,
                            }}
                          />
                        )}
                        {((payroll.contractType === "FDC") && (groupPayroll?.payrollPeriod === "second_payment" || groupPayroll?.payrollPeriod === "final_payment")) && (
                          <Button
                            type="default"
                            shape="circle"
                            icon={
                              <DollarOutlined
                                style={{
                                  fontSize: 10,
                                  position: "absolute",
                                  top: 2,
                                  left: 1.5,
                                }}
                              />
                            }
                            onClick={() => hadleOpenModalSeverancePay(payroll)}
                            style={{
                              minWidth: 16,
                              width: 16,
                              height: 16,
                              position: "absolute",
                              left: 48,
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td className="frozencol1" style={{ borderWidth: 0 }}></td>
                  <td className="frozencol2" style={{ borderWidth: 0 }}></td>
                  <td
                    className="frozencol3"
                    style={{
                      height: 30,
                      borderLeftWidth: 0,
                      borderBottomWidth: 0,
                    }}
                  ></td>
                  {/* <td></td> */}
                  {/* <td></td> */}
                  {/* <td></td> */}
                  <td></td>
                  <td></td>
                  {/* PROJECT ALLOCATION */}
                  {/* {
                                        projects.map((project, key) => <td key={key}
                                            style={{ textAlign: "center", padding: 0 }}></td>)
                                    } */}
                  {/* END PROJECT ALLOCATION */}
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    {Util.getInstance().formatCurrency(monthlyPayBasic)}
                  </td>
                  <td></td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    {Util.getInstance().formatCurrency(monthlyCurrentPayBasic)}
                  </td>
                  {payrollItems.map((payrollItem, key) => {
                    if (payrollItem.amount && payrollItem.format === "USD") {
                      payrollItem.amount = parseFloat(payrollItem.amount);
                      payrollItem.amount = payrollItem.amount.toFixed(2);
                    }

                    if (
                      payrollItem.code === "nssf_occupational_accident" ||
                      payrollItem.code === "nssf_health_care" ||
                      payrollItem.code === "total_nssf_both_staff_npa"||
                        payrollItem.code === "gross_pay_second_pay"
                    ) {
                      return (
                        <td key={key} style={{ display: "none" }}>
                          <div style={{ minWidth: 60 }}></div>
                        </td>
                      );
                    }

                    if (payrollItem.format === "NONE")
                      return (
                        <td
                          key={key}
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#eeeeee",
                            textAlign: "center",
                          }}
                        >
                          {payrollItem.amount
                            ? parseFloat(payrollItem.amount)
                                .toFixed(1)
                                .replace(/\.0+$/, "")
                            : "-"}
                        </td>
                      );
                    if (payrollItem.format === "KHR")
                      return (
                        <td
                          key={key}
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#eeeeee",
                            textAlign: "right",
                          }}
                        >
                          {payrollItem.amount
                            ? Util.getInstance().formatCurrencyKHR(
                                payrollItem.amount * exchangeRate
                              )
                            : "-"}
                        </td>
                      );
                    if (payrollItem.format === "KHR-FIXED")
                      return (
                        <td
                          key={key}
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#eeeeee",
                            textAlign: "right",
                          }}
                        >
                          {payrollItem.amount
                            ? Util.getInstance().formatCurrencyKHR(
                                payrollItem.amount * 4000
                              )
                            : "-"}
                        </td>
                      );
                    if (payrollItem.format === "PERCENTAGE")
                      return (
                        <td
                          key={key}
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#eeeeee",
                            textAlign: "center",
                          }}
                        >
                          {"-"}
                        </td>
                      );

                    return (
                      <td
                        key={key}
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#eeeeee",
                          textAlign: "right",
                        }}
                      >
                        {payrollItem.amount
                          ? Util.getInstance().formatCurrency(
                              payrollItem.amount
                            )
                          : "-"}
                      </td>
                    );
                  })}
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(accrual13thMonth)}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(
                      uptodateAccrual13thMonth
                    )}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(accrualSeniority)}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(accrualSeniorityUptoDate)}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(accrualSeverancePay)}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(
                      uptodateAccrualSeverancePay
                    )}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(accrualPFOrganization)}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(PFOrganization)}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(PFStaff)}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: bgHeaders["1"],
                    }}
                  >
                    {Util.getInstance().formatCurrency(
                      PFStaff + PFOrganization
                    )}
                  </td>
                  <td
                    className="frozennetpay"
                    style={{
                      fontWeight: "bold",
                      backgroundColor: "#eeeeee",
                    }}
                  >
                    {Util.getInstance().formatCurrency(totalNetPay)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style={{
              position: "absolute",
              left: 0,
              marginTop: 15,
              marginLeft: 15,
            }}
          >
            {pagination.offset + 1}-{pagination.offset + pagination.count} of{" "}
            {pagination.total} items
          </div>

          <Modal
            title="Update Severance Pay"
            visible={isModalSeverancePay}
            onOk={() => {}}
            onCancel={() => {
              setIsModalSeverancePay(false);
              setLoadingSeverancePay(false);
              setSeverancePayFinal({
                id: 0,
                employeeId: 0,
                severancePay: 0,
              });
            }}
          >
            <InputNumber
              precision={2}
              style={{ width: "100%" }}
              type="number"
              value={severancePayFinal.severancePay}
              onChange={(value) => {
                setSeverancePayFinal((pre) => ({
                  ...pre,
                  severancePay: value,
                }));
              }}
            />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                style={{ marginTop: 10 }}
                type="primary"
                htmlType="button"
                onClick={onChangeSeverancePay}
                loading={loadingSeverancePay}
              >
                {t("text_save")}
              </Button>
            </div>
          </Modal>
          <SummayPayroll
            data={[
              {
                label: "Net First Pay:",
                value: Util.getInstance().formatCurrency(
                  summaryPayroll.firstNetPayment
                    ? summaryPayroll.firstNetPayment
                    : 0
                ),
              },
              {
                label: "Net Second Pay:",
                value: Util.getInstance().formatCurrency(
                  summaryPayroll.secondNetPayment
                    ? summaryPayroll.secondNetPayment
                    : 0
                ),
              },
              {
                label: "Net Pay:",
                value: Util.getInstance().formatCurrency(
                  summaryPayroll.firstNetPayment +
                    summaryPayroll.secondNetPayment
                ),
              },
            ]}
          />
        </div>
      </>
    );
  };
}

function SummayPayroll({ data }) {
  const containerStyle = {
    position: "absolute",
    right: 83,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  };

  const rowStyle = {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  };

  const labelStyle = {
    marginRight: 10,
    paddingTop: 5,
    paddingBottom: 5,
    fontWeight: "bold",
    fontSize: "11px",
  };

  const valueStyle = {
    width: 100,
    paddingTop: 5,
    paddingBottom: 5,
    paddingRight: 10,
    fontWeight: "bold",
    textAlign: "right",
    fontSize: "11px",
    backgroundColor: "#eeeeee",
    borderBottom: "1px solid #dddddd",
  };

  return (
    <div style={containerStyle}>
      {data.map(({ label, value }) => (
        <div style={rowStyle} key={label}>
          <div style={labelStyle}>{label}</div>
          <div style={valueStyle}>{value}</div>
        </div>
      ))}
    </div>
  );
}

function GeneratePayroll({ onReload }) {
  const [resignedEmployees, setResignedEmployees] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [visible, setVisible] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (!visible) {
      form.setFieldsValue({ date: null });
      setResignedEmployees([]);
    }

    // eslint-disable-next-line
  }, [visible]);

  const onClose = () => {
    setVisible(false);
    setSelectedRows([]);
    form.resetFields(["date"]);
  };

  const onFinish = (values) => {
    swal({
      title: "Are you sure?",
      text: `You are about to generate payroll for ${moment(values.date).format(
        "MMM YYYY"
      )}.`,
      icon: "warning",
      buttons: ["Cancel", "Generate"],
      dangerMode: true,
    })
      .then((willGenerate) => {
        if (willGenerate) {
          setSubmitting(true);
          const resignedEmployeeIds = selectedRows.map(
            (selectedRow) => selectedRow.id
          );
          generatePayroll(
            moment(values.date).format("YYYY-MM-DD"),
            resignedEmployeeIds
          )
            .then((response) => {
              const payrolls = response?.data?.data?.data;
              swal(
                "Generated!",
                `You've generated ${payrolls.length} payroll!`,
                "success"
              ).then(() => {
                onReload();
              });
            })
            .finally(() => setSubmitting(false));
        } else {
          swal("Cancelled", "Payroll generation was cancelled", "error");
        }
      })
      .finally(() => setVisible(false));
  };

  const onSelectPayrollDate = (payrollDate) => {
    getResignedEmployes(payrollDate.format("YYYY-MM-DD")).then((response) => {
      if (response?.data) {
        setResignedEmployees(response.data);
      }
    });
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows);
    },
  };

  const onShow = () => {
    setVisible(true);
  };

  return (
    <>
      <Button onClick={onShow} style={{ marginLeft: 15 }}>
        {t("text_generate")}
      </Button>

      <Drawer
        title={
          <div style={styles.headerFilter}>
            <div>Generate Payroll</div>
            <div></div>
          </div>
        }
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        id="exchange-payroll"
        width={400}
      >
        <Form form={form} onFinish={onFinish}>
          <InputMonth
            name="date"
            label="Month"
            required={true}
            errorMessage="Please select month"
            format="MM/YYYY"
            placeholder={"MM/YYYY"}
            onChange={onSelectPayrollDate}
            style={{ width: 340 }}
          />

          {resignedEmployees.length > 0 && (
            <div style={{ paddingLeft: 15, paddingRight: 15, marginTop: 25 }}>
              <div style={{ fontWeight: "bold", marginBottom: 10 }}>
                Resigned Employees
              </div>
              <Table
                rowKey="id"
                dataSource={resignedEmployees}
                rowSelection={rowSelection}
                pagination={false}
                columns={[
                  {
                    title: "Name",
                    dataIndex: "name",
                    key: "name",
                  },
                  {
                    title: "Code",
                    dataIndex: "code",
                    key: "code",
                  },
                  {
                    title: "Last Working Day",
                    dataIndex: "lastWorkingDay",
                    key: "lastWorkingDay",
                    render: (lastWorkingDay) =>
                      moment(lastWorkingDay).format("DD/MM/YYYY"),
                  },
                ]}
              />
            </div>
          )}
          <Button
            type="primary"
            htmlType="submit"
            style={{ position: "absolute", top: 10, right: 8 }}
            loading={submitting}
          >
            {t("text_generate")}
          </Button>
        </Form>
      </Drawer>
    </>
  );
}

function RejectPayroll({ groupPayrollId, onReload }) {
  const [visible, setVisible] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [form] = Form.useForm();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const onClose = () => {
    setVisible(false);
  };

  const onFinish = (values) => {
    swal({
      title: "Are you sure?",
      text: `You are about to rejecte payroll.`,
      icon: "warning",
      buttons: ["Cancel", "Submit"],
      dangerMode: true,
    })
      .then((willReject) => {
        if (willReject) {
          setSubmitting(true);
          markAsRejected(
            groupPayrollId,
            values.comment,
            params.has("date")
              ? moment(params.get("date")).format("YYYY")
              : moment().format("YYYY")
          )
            .then(() => {
              swal("Rejected!", `You've rejected payroll!`, "success").then(
                () => {
                  onReload();
                }
              );
            })
            .finally(() => setSubmitting(false));
        } else {
          swal("Cancelled", "Payroll rejection was cancelled", "error");
        }
      })
      .finally(() => setVisible(false));
  };

  const onShow = () => {
    setVisible(true);
  };

  return (
    <>
      <Button style={{ marginLeft: 15 }} type="primary" danger onClick={onShow}>
        Reject
      </Button>
      <Drawer
        title="Payroll Rejection"
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        id="exchange-payroll"
        width={400}
      >
        <Form form={form} onFinish={onFinish}>
          <InputTextArea
            name="comment"
            label="Comment"
            requiredMessage="Please enter comment"
            rows={6}
          />
          <Button
            type="primary"
            htmlType="submit"
            style={{ position: "absolute", top: 10, right: 8 }}
            loading={submitting}
          >
            {t("text_submit")}
          </Button>
        </Form>
      </Drawer>
    </>
  );
}

function ProcessPayRoll({ onReload, groupPayroll }) {
  const [form] = Form.useForm();
  const [visible, setVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const onClose = () => {
    setVisible(false);
    form.resetFields(["exchangeRate", "nssfExchangeRate", "payrollPeriod"]);
  };

  const onFinish = (values) => {
    const lockedErrorMessages = {
      VERIFIED: "Payroll was verified",
      APPROVED: "Payroll was approved",
    };
    const lockedPayrollStatus = ["VERIFIED", "APPROVED"];
    if (
      values["payrollPeriod"] === "first_payment" &&
      lockedPayrollStatus.includes(groupPayroll?.firstPaymentStatus)
    ) {
      swal(
        "Payroll Process",
        lockedErrorMessages[groupPayroll?.firstPaymentStatus],
        "error"
      );
      return;
    }

    if (
      values["payrollPeriod"] === "second_payment" &&
      lockedPayrollStatus.includes(groupPayroll?.secondPaymentStatus)
    ) {
      swal(
        "Payroll Process",
        lockedErrorMessages[groupPayroll?.secondPaymentStatus],
        "error"
      );
      return;
    }

    swal({
      title: "Are you sure?",
      text: "This will process the payroll for all employees. Do you want to continue?",
      icon: "warning",
      buttons: ["No, cancel", "Yes, process payroll!"],
    }).then((yes) => {
      if (yes) {
        const params = new URLSearchParams(document.location.search);
        values["search"] = params.has("search") ? params.get("search") : "";
        values["month"] = params.has("date")
          ? moment(params.get("date")).format("YYYY-MM")
          : "";
        setLoading(true);
        processPayroll(values)
          .then(() => {
            onReload();
          })
          .catch((error) => {
            if (error?.response?.status === 400) {
              swal({
                title: "Opps!",
                text: error?.response?.data?.error?.message,
                icon: "error",
                dangerMode: true,
              }).then(() => {
                onReload();
              });
            }
          })
          .finally(() => {
            onClose();
            setLoading(false);
          });
      }
    });
  };
  const onShow = () => {
    setVisible(true);
  };

  return (
    <>
      <Button
        icon={<CalculatorOutlined />}
        onClick={onShow}
        style={{ marginLeft: 10 }}
        type="primary"
      >
        {t("text_process")}
      </Button>
      <Drawer
        title={
          <div style={styles.headerFilter}>
            <div>{t("text_process_payroll")}</div>
            <div></div>
          </div>
        }
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        id="exchange-payroll"
      >
        <Form form={form} onFinish={onFinish}>
          <NumberInput
            label={t("text_exchange_rate")}
            name="exchangeRate"
            placeholder="Enter tax exchange rate"
            required={true}
            errorMessage="Tax exchange rate is required"
          />
          <NumberInput
            label={t("text_nssf_exchange_rate")}
            name="nssfExchangeRate"
            placeholder="Enter NSSF exchange rate"
            errorMessage="NSSF exchange rate is required"
            required={true}
          />
          <SelectInput
            label={t("text_payrol_period")}
            name="payrollPeriod"
            placeholder={t("text_please_select_payrol_period")}
            errorMessage="Period is required"
            required={true}
            nameKey="name"
            valueKey="id"
            dataSource={[
              { id: "first_payment", name: "First Payment" },
              { id: "second_payment", name: "Second Payment" },
              { id: "final_payment", name: "Final Payment" },
            ]}
          />
          <Button
            type="primary"
            htmlType="submit"
            style={{ position: "absolute", top: 10, right: 8 }}
            loading={loading}
          >
            {t("text_submit")}
          </Button>
        </Form>
      </Drawer>
    </>
  );
}

function ExportButton() {
  const [visible, setVisible] = React.useState(false);
  const [visibleChostSharing, setVisibleChostSharing] = React.useState(false);
  const [payrollPeriod, setPayrollPeriod] = React.useState("first_payment");

  const onClose = () => {
    setVisible(false);
    setVisibleChostSharing(false);
  };

  const onShowExportPayroll = (period) => {
    setVisible(true);
    setPayrollPeriod(period);
  };

  return (
    <>
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item
              key={0}
              onClick={() => onShowExportPayroll("first_payment")}
            >
              Payroll - 1<sup>st</sup> Payment
            </Menu.Item>
            <Menu.Item
              key={1}
              onClick={() => onShowExportPayroll("second_payment")}
            >
              Payroll - 2<sup>rd</sup> Payment
            </Menu.Item>
            <Divider style={{ margin: 0 }} />
          </Menu>
        }
      >
        <Button style={{ marginLeft: 10 }}>
          {t("text_export")}
          <DownOutlined style={{ fontSize: 14 }} />
        </Button>
      </Dropdown>
      <Drawer
        title={
          <div style={styles.headerFilter}>
            <div>{t("text_export_report")}</div>
            <div>
              <CloseOutlined onClick={onClose} />
            </div>
          </div>
        }
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible || visibleChostSharing}
      >
        {visible && <ExportPayrollFormLoader payrollPeriod={payrollPeriod} />}
        {visibleChostSharing && (
          <ExportCostSharingFormLoader payrollPeriod={payrollPeriod} />
        )}
      </Drawer>
    </>
  );
}

function ExportPayrollFormLoader({ payrollPeriod }) {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let option = {};
    if (params.has("date")) {
      option["date"] = params.get("date");
    }

    option["payrollPeriod"] = payrollPeriod;

    if (params.has("search")) {
      option["search"] = params.get("search");
    }

    option["isExport"] = true;

    getMany(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      })
      .catch((error) => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title="Payroll successfully exported to the designated folder on the following link"
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a
                key="1"
                className="ant-btn ant-btn-dashed"
                href={result ? result.link : "#"}
              >
                {t("text_download_file_xlsx")}
              </a>
            </div>,
          ]}
        />
      )}
    </>
  );
}

function ExportCostSharingFormLoader({ payrollPeriod }) {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    option["payrollPeriod"] = payrollPeriod;

    option["isExport"] = true;

    getCoshSharing(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      })
      .catch((error) => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title="Cost sharing successfully exported to the designated folder on the following link"
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a
                key="1"
                className="ant-btn ant-btn-dashed"
                href={result ? result.link : "#"}
              >
                {t("text_download_file_xlsx")}
              </a>
            </div>,
          ]}
        />
      )}
    </>
  );
}

function Title({ title }) {
  return <h4 style={{ marginBottom: 0, fontWeight: 600 }}>{title}</h4>;
}

function MonthPicker({
  pathName,
  fetchList,
  dateFormat,
  datePlaceholder,
  showFetchListDate,
  pickerDate,
}) {
  const util = new Util();
  const params = new URLSearchParams(document.location.search);
  const onChangeDate = (value) => {
    if (value) {
      params.set("date", moment(value).format("YYYY-MM-DD"));
    } else {
      params.delete("date");
    }

    util.pushParamsToURL(pathName, params.toString());
    if (showFetchListDate) fetchList();
  };

  return (
    <DatePicker
      name="month"
      placeholder={datePlaceholder}
      format={dateFormat}
      onChange={onChangeDate}
      style={{ width: 140, marginLeft: "10px" }}
      picker={pickerDate}
      defaultValue={params.get("date") && moment(params.get("date"))}
    />
  );
}

const styles = {
  generalSearch: {
    width: 250,
  },
  headerFilter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  breadCream: {
    paddingBottom: 15,
    backgroundColor: "#EFF3F6",
  },
  style: {
    background: "#0092ff",
    padding: "8px 0",
  },
};
